import { realBricksApi } from '../../utils/axiosInterceptors';

export const fetchPortfolioCardData = async () => {
  const response = await realBricksApi.get(`/api/v1/portfolio/portfolio-statistics`);
  return response.data;
};

export const fetchOpenOrderData = async ({ page, perPage }) => {
  const response = await realBricksApi.get(`/api/v1/portfolio/open-orders?${page && `page=${page}`}${perPage && `&perPage=${perPage}`}`);
  return response.data;
};

export const getAccountValue = async (data, { rejectWithValue }) => {
  const { onFail = () => {}, onSuccess = () => {} } = data;
  try {
    const response = await realBricksApi.get(`/api/v1/portfolio/account-value`);
    onSuccess();
    return response.data;
  } catch (err) {
    onFail();
    return rejectWithValue(err?.response?.data?.message);
  }
};

export const getLastDividend = async (data, { rejectWithValue }) => {
  const { onFail = () => {}, onSuccess = () => {} } = data;
  try {
    const response = await realBricksApi.get(`/api/v1/portfolio/dividend`);
    onSuccess();
    return response.data;
  } catch (err) {
    onFail();
    return rejectWithValue(err?.response?.data?.message);
  }
};

export const fetchPortfolioChart = async (timeline) => {
  const response = await realBricksApi.get(`/api/v1/portfolio/chart-data/${timeline}`);
  return response.data;
};
export const fetchPortfolioOwnedAssets = async (data, { rejectWithValue }) => {
  const { onFail = () => {}, onSuccess = () => {}, propertyId } = data;
  try {
    const response = await realBricksApi.get(`/api/v1/portfolio/owned-asset-detail/${propertyId}`);
    onSuccess();
    return response.data;
  } catch (err) {
    onFail();
    return rejectWithValue(err?.response?.data?.message);
  }
};

export const fwtchOwnedAssetCharts = async (propertyId, chartType) => {
  const response = await realBricksApi.get(`/api/v1/portfolio/owned-asset-chart-data/${propertyId}/${chartType}`);
  return response.data;
};
